// extracted by mini-css-extract-plugin
module.exports = {"icon":"MenuItem_icon__FmfrP"};